import { render, staticRenderFns } from "./Amazon.vue?vue&type=template&id=73d2e63c&scoped=true"
import script from "./Amazon.vue?vue&type=script&lang=js"
export * from "./Amazon.vue?vue&type=script&lang=js"
import style0 from "../index.css?vue&type=style&index=0&id=73d2e63c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0_supports-_afcd48d4a41aa41dd7c763bb85ff8663/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2e63c",
  null
  
)

export default component.exports